const SvgHomeHeroAlt = (props) => (
  <svg viewBox="0 0 780 390" xmlns="http://www.w3.org/2000/svg">
    <path d="M467 130v259H209l258-259Z" fill="#29A964" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M274.543 322.884c15.783 15.783 37.586 25.545 61.67 25.545 48.167 0 87.214-39.047 87.214-87.214 0-24.084-9.762-45.888-25.544-61.67l-123.34 123.339Z"
      fill="#EFAC26"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M422.713 249.991c-2.518-19.595-11.539-37.156-24.829-50.446L274.545 322.884C258.762 307.102 249 285.298 249 261.214 249 213.047 288.047 174 336.214 174c44.364 0 80.992 33.125 86.499 75.991Z"
      fill="#F06C22"
    />
    <path fill="#4D74FF" d="M467 130h258v259H467z" />
    <path d="M544 234.5c0-28.995 23.505-52.5 52.5-52.5s52.5 23.505 52.5 52.5V390H544V234.5Z" fill="#363636" />
    <path fill="#4D74FF" d="M725 289h55v100h-55zM598 289h56v100h-56z" />
    <path fill="#2525D7" d="M649 289h76v100h-76z" />
    <circle cx={144} cy={325} r={65} fill="#BC6038" />
    <circle cx={632} cy={65} r={65} fill="#F2D6BB" />
    <path d="M33.59 337 66 389H0l33.59-52Z" fill="#4D74FF" />
  </svg>
);

export default SvgHomeHeroAlt;
